angular.module('qkr').factory('reportService', ($http, appConfig, $q, utils, gettextCatalog) => ({

        /* General Report Functions */
    loadSavedReports(form) {
        if(form == null) {
            form = {
                offset: 0,
                max: 10                     // Fixes 'property shorthand' eslint warning, no need to sign value to itself.
            };
        }
        const deferred = $q.defer();

        $http.post(appConfig.apiUrl + 'reportSpec/getReportSpecList', angular.copy(form)).then(
            (response) => {
                deferred.resolve(response.data);
            },
            (reason) => {
                deferred.reject(reason.data);
            }
        );
        return deferred.promise;
    },
        suspendReport(savedReport, date) {
            date.setHours(savedReport.scheduleHour);
            date.setMinutes(savedReport.scheduleMinute);
            const suspendReportUntilDate = date.getTime();

            const suspendReportCommand = {
                reportId: {id: savedReport.id},
                suspendReportUntilDate
            };

            return $http.post(appConfig.apiUrl + 'reportSpec/suspend', suspendReportCommand, {withCredentials: true})
                .then(response => response.data);
        },

        unsuspendReport(id) {
            const suspendReportCommand = {
                reportId: {id}
            };
            return $http.post(appConfig.apiUrl + 'reportSpec/unsuspend', suspendReportCommand, {withCredentials: true})
                .then(response => response.data);
        },

        pollReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/get', {withCredentials: true})
                .then(response => response.data);
        },

        // PERK REPORT
        generatePerkReport(report) {
            return $http.post(appConfig.apiUrl + 'perkReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        savePerkReport(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'perkReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'perkReportSpec/create', report, {withCredentials: true})
                    .then(response => response.data);
            }
        },

        loadSavedPerkReports() {
            return $http.get(appConfig.apiUrl + 'perkReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getPerkReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deletePerkReport(id) {
            return $http.post(appConfig.apiUrl + 'perkReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        generateStickerReport(report) {
            return $http.post(appConfig.apiUrl + 'stickerReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        saveStickerReport(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'stickerReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'stickerReportSpec/create', report, {withCredentials: true})
                    .then(response => response.data);
            }
        },

        loadSavedStickerReports() {
            return $http.get(appConfig.apiUrl + 'stickerReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getStickerReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deleteStickerReport(id) {
            return $http.post(appConfig.apiUrl + 'stickerReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        getStickerReportFilters() {
            return $http.get(appConfig.apiUrl + 'reportFilters/stickerReport', {withCredentials: true})
                .then(response => response.data);
        },

        /* Tally Report */
        generateTallyReport(report) {
            return $http.post(appConfig.apiUrl + 'tallyReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        saveTallyReport(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'tallyReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'tallyReportSpec/create', report, {withCredentials: true})
                    .then(response => response.data);
            }
        },

        loadSavedTallyReports() {
            return $http.get(appConfig.apiUrl + 'tallyReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getTallyReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deleteTallyReport(id) {
            return $http.post(appConfig.apiUrl + 'tallyReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        getTallyReportFilters() {
        	return $http.get(appConfig.apiUrl + 'reportFilters/list', {withCredentials: true})
                .then(response => response.data);
        },

        /* Transaction Report */
        generateTransactionReport(report) {
            return $http.post(appConfig.apiUrl + 'transactionReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

         saveTransactionReport(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'transactionReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'transactionReportSpec/create', report, {withCredentials: true})
                    .then((response) => (response.data));
            }
        },

        loadSavedTransactionReports() {
            return $http.get(appConfig.apiUrl + 'transactionReportSpec/list', {withCredentials: true})
                .then((response) => (response.data),
                (reason) => deferred.reject(reason.data));
        },

        getTransactionReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deleteTransactionReport(id) {
            return $http.post(appConfig.apiUrl + 'transactionReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data)
        },

        /* Stock Report */
        generateStockReport(report) {
            return $http.post(appConfig.apiUrl + 'stockLevelReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        saveStockReport(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'stockLevelReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'stockLevelReportSpec/create', report, {withCredentials: true})
                    .then((response) => (response.data));
            }
        },

        loadSavedStockReports() {
            return $http.get(appConfig.apiUrl + 'stockLevelReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getStockReport(id) {
            return $http.get(appConfig.apiUrl + 'stockLevelControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deleteStockReport(id) {
            return $http.post(appConfig.apiUrl + 'stockLevelReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        /* Cases 21 Report */
        generateCases21Report(report) {
            return $http.post(appConfig.apiUrl + 'cases21ReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        saveCases21Report(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'cases21ReportSpec/update', report, {withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'cases21ReportSpec/create', report, {withCredentials: true})
                    .then((response) => (response.data));
            }
        },

        loadSavedCases21Reports() {
            return $http.get(appConfig.apiUrl + 'cases21ReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getCases21Report(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then(response => response.data);
        },

        deleteCases21Report(id) {
            return $http.post(appConfig.apiUrl + 'cases21ReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        /* Finance 1 Report */
        generateFinance1Report(report) {
            return $http.post(appConfig.apiUrl + 'finance1ReportSpec/generate', report, {withCredentials: true})
                .then((response) => (response.data),
                (reason) => deferred.reject(reason.data));
        },

        saveFinance1Report(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'finance1ReportSpec/update', report, {withCredentials: true})
                    .then((response) => (response.data),
                    (reason) => deferred.reject(reason.data));
            } else {
                return $http.post(appConfig.apiUrl + 'finance1ReportSpec/create', report, {withCredentials: true})
                    .then((response) => (response.data));
            }
        },

        loadSavedFinance1Reports() {
            return $http.get(appConfig.apiUrl + 'finance1ReportSpec/list', {withCredentials: true})
                .then((response) => (response.data),
                (reason) => deferred.reject(reason.data));
        },

        deleteFinance1Report(id) {
            return $http.post(appConfig.apiUrl + 'finance1ReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        /* Reconciliation Report */
        generateReconciliationReport(report) {
            return $http.post(appConfig.apiUrl + 'reconciliationReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        createReconciliationReport(report) {
            return $http.post(appConfig.apiUrl + 'reconciliationReportSpec/create', report, {withCredentials: true})
                .then(response => response.data);
        },

        updateReconciliationReport(report) {
            return $http.post(appConfig.apiUrl + 'reconciliationReportSpec/update', report, {withCredentials: true})
                .then(response => response.data);
        },

        loadSavedReconciliationReports() {
            return $http.get(appConfig.apiUrl + 'reconciliationReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        getReconciliationReport(id) {
            return $http.get(appConfig.apiUrl + 'reportControl/' + id + '/report', {withCredentials: true})
                .then((response) => (response.data),
                    (reason) => deferred.reject(reason.data));
        },

        deleteReconciliationReport(id) {
            return $http.post(appConfig.apiUrl + 'reconciliationReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        /* Form PDF Report */
        generateFormPdfReport(report) {
            return $http.post(appConfig.apiUrl + 'formPdfReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        /* General Partner Report Functions */
        loadSavedFinance1PartnerReports() {
            return $http.get(appConfig.apiUrl + 'partnerFinance1ReportSpec/list', {withCredentials: true})
                .then(response => response.data);
        },

        generatePartnerFinance1Report(report) {
            return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/generate', report, {withCredentials: true})
                .then(response => response.data);
        },

        savePartnerFinance1Report(report, isUpdating) {
            if (isUpdating) {
                return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/update', report,{withCredentials: true})
                    .then(response => response.data);
            } else {
                return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/create', report,{withCredentials: true})
                    .then(response => response.data);
            }
        },

        deletePartnerFinance1Report(id) {
            return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/delete', {id}, {withCredentials: true})
                .then(response => response.data);
        },

        suspendPartnerReport(savedReport, date) {
            date.setHours(savedReport.scheduleHour);
            date.setMinutes(savedReport.scheduleMinute);
            const suspendReportUntilDate = date.getTime();

            const suspendReportCommand = {
                reportId: {id: savedReport.id},
                suspendReportUntilDate
            };

            return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/suspend', suspendReportCommand,
                {withCredentials: true}).then(response => response.data);
        },

        unsuspendPartnerReport(id) {
            const suspendReportCommand = {
                reportId: {id}
            };
            return $http.post(appConfig.apiUrl + 'partnerFinance1ReportSpec/unsuspend', suspendReportCommand,
                {withCredentials: true}).then(response => response.data);
        },

    /* Utils */
        getDateTime(hours, minutes, seconds) {
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(seconds);
            return date;
        },

        getScheduleIntervals() {
            return [
                {name: gettextCatalog.getString('Daily'), value: 'daily'},
                {name: gettextCatalog.getString('Weekly'), value: 'weekly'},
                {name: gettextCatalog.getString('Monthly'), value: 'monthly'}
            ];
        },

        getAnytimeMenuScheduleIntervals() {
            return [
                {name: gettextCatalog.getString('Daily'), value: 'daily'}
            ];
        },

        /** Used by transaction and Cases21 reports for Australian schools */
        getExtendedScheduleIntervals() {
            return [
                {name: gettextCatalog.getString('Daily'), value: 'daily'},
                {name: gettextCatalog.getString('Daily Bank Cutoff'), value: 'dayRec'},
                {name: gettextCatalog.getString('Weekly'), value: 'weekly'},
                {name: gettextCatalog.getString('Monthly'), value: 'monthly'}
            ];
        },

        getDaysOfMonth() {
            // Loads days of month
            const daysOfMonth = [];

            for (let i = 1; i <= 31; i++) {
                daysOfMonth.push(i);
            }

            return daysOfMonth;
        },

        getHours() {
            // Loads hours of day
            const hours = [];

            for (let i = 0; i <= 23; i++) {
                hours.push({name: utils.twoDecimalPlaces(i), value: i});
            }

            return hours;
        },

        getMinutes() {
            // Loads minutes
            const minutes = [];

            for (let i = 0; i <= 59; i++) {
                minutes.push({name: utils.twoDecimalPlaces(i), value: i});
            }

            return minutes;
        },

        // Set every day for sticker and tally and let server decide if should be sent
        getDefaultDays() {
            return utils.localizeWeek([
                            gettextCatalog.getString('SUN'),
                            gettextCatalog.getString('MON'),
                            gettextCatalog.getString('TUE'),
                            gettextCatalog.getString('WED'),
                            gettextCatalog.getString('THU'),
                            gettextCatalog.getString('FRI'),
                            gettextCatalog.getString('SAT')
            ]).join();
        },

        getDefaultCutOffTimeOffset() {
            return 540;  // Default to 09:00 AM
        },

        getReportType(report) {
            const reportTypes = {
                TallyReportSpec : 'Tally',
                TransactionReportSpec : 'Transaction',
                StickerReportSpec : 'Sticker',
                Cases21ReportSpec: 'Accountancy',
                StockLevelReportSpec: 'Stock',
                Finance1ReportSpec: 'Accountancy',
                ReconciliationReportSpec: 'Reconciliation',
                PerkReportSpec: 'Redemption',
                PartnerFinance1ReportSpec: 'Accountancy'
            };
            return reportTypes[report.bean] ? reportTypes[report.bean] : 'Unknown';
        },

        scheduleSummary(savedReport) {
            if (savedReport.scheduleInterval === 'dayRec') {
                return 'Daily Bank Cutoff';
            } else {
                const t = utils.twoDecimalPlaces(savedReport.scheduleHour) + ':'
                    + utils.twoDecimalPlaces(savedReport.scheduleMinute);
                return savedReport.scheduleInterval + ' ' + t;
            }
        },

        getDefaultScheduledDay(newValue, scheduleDays) {
            if (newValue !== 'daily' && scheduleDays.indexOf(',') > -1) {
                const dayArray = scheduleDays.split(',');
                return dayArray[0];
            }
        },

        /** Is Synergetic or is similar (QKRD-2035) */
        isSynergeticType(accountancyPackageName) {
            // All Accountancy systems apart from CASES21 and MAZE are treated like synergetic
            return (accountancyPackageName !== 'Cases21' && accountancyPackageName !== 'MAZE');
        },

        filterReportsNonSchoolOutlet(reports, currentOutletSession) {
            const addOutletChildIdToReport = (item) => {
                // should have only one merchantLoc
                const merchantLoc = item.merchantLocs[0];
                item.outletChildId = merchantLoc && merchantLoc.id === currentOutletSession.id ?
                    merchantLoc.id : null;
                return item;
            };

            return reports
                .map(addOutletChildIdToReport)
                .filter(report => report.outletChildId)
        },

        addDate(reports) {
            return reports.map(report => {
                if (report.suspended) {
                    report.nextScheduledGenerationDisplay = utils
                        .serverDateStringtoDate(report.nextScheduledGenerationDisplay);
                }
                return report;
            });
        }
    }));




// WEBPACK FOOTER //
// ./src/services/report.services.js